<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <CleanTriggeredEventList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CleanTriggeredEventList from "@/components/settings/arena/clean-triggered-event/CleanTriggeredEventList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "CleanTriggeredEvent",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    CleanTriggeredEventList,
  },
};
</script>
